<template>
    <div class="mc-report-view__table">
        <div class="row">
            <!-- Search -->
            <div class="col-md-12">
                <div class="mc-table-view">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end float-end">
                        <label class="d-inline-flex align-items-center mc-table-view__search">
                            <i class="mc-fa fas fa-search"></i>
                            <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'"
                                class="ms-2" @input="searchData"></b-form-input>
                        </label>
                    </div>
                </div>
            </div>
            <!-- End search -->
        </div>

        <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
            <b-skeleton-wrapper :loading="isLoading">
                <template #loading>
                    <b-card>
                        <b-skeleton-table :rows="3" :columns="fields.length"
                            :table-props="{ bordered: false, striped: true }">
                        </b-skeleton-table>
                    </b-card>
                </template>
                <div class="datatables table-responsive-sm">
                    <table class="table b-table table-sm" aria-describedby="Driver Score Table">
                        <thead>
                            <tr>
                                <th v-for="field in fields" id="header" :key="field.key" :colspan="field.headerColspan"
                                    :rowspan="field.headerRowspan" style="text-align: center">
                                    {{ field.label }}
                                </th>
                            </tr>
                            <tr>
                                <th id="sub-header" v-for="field in childFields[0].children" :key="field.key"
                                    :colspan="field.headerColspan">
                                    {{ field.label }}
                                </th>
                                <th id="sub-header" v-for="field in childFields[1].children" :key="field.key"
                                    :colspan="field.headerColspan">
                                    {{ field.label }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="report in reportDriverScores.reportDriverScores" :key="report.driverId">
                                <td v-for="key in selectedData" :key="key">
                                    {{
                                        key == 'totalDriven'
                                        ? minimizeFloat(report[key])
                                            .toString()
                                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                        : key == 'driver'
                                            ? report[key].fullname
                                            : key == 'totalHours'
                                                ? formatTotalHours(report[key])
                                                : report[key]
                                    }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </b-skeleton-wrapper>
        </div>
        <div class="row mt-3" v-if="fields.length > 0">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                        {{ $t('global.text.displays') }}
                        <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions"
                            @input="changePerPage">
                        </b-form-select>
                        {{ $t('global.text.entries') }}.
                        <p>
                            {{ $t('global.text.display') }}
                            <strong>{{ totalRows > 0 ? (currentPage - 1) * perPage + 1 : 0 }}</strong> -
                            <strong>{{ Math.min(totalRows, currentPage * perPage) }}</strong>
                            {{ $t('global.object.of') }}
                            <strong>{{ totalRows }}</strong>
                        </p>
                    </label>
                </div>
            </div>
            <div class="col-sm-12 col-md-6">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows"
                            :per-page="perPage" @change="changePage">
                        </b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GET_REPORT_DRIVER_SCORES } from '@/services/api/report/report'
import moment from 'moment'
import { Helper, debounce } from '@/mixin/helper'
import { Export } from '@/mixin/export'
import { EXPORT_PDF_REPORT_DRIVER_SCORES } from '@/services/api/report/pdf'
import { EXPORT_EXCEL_REPORT_DRIVER_SCORES } from '@/services/api/report/excel'
moment.locale('id')

export default {
    name: 'DriverScoreTable',
    mixins: [Helper, Export],
    data() {
        return {
            tableData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterDriver: [],
            filterGrade: [],
            filterOn: [],
            reportDriverScores: {
                reportDriverScores: [],
            },
            fields: [],
            isLoading: false,
            fileName: '',
            openSection: false,
            periode: [],
            filteredItems: [],
            selectedData: [],
        }
    },
    computed: {
        /**
         * Total no. of records
         */
        rows() {
            return this.reportDriverScores.reportDriverScores.length
        },
        childFields() {
            const filteredData = this.fields.filter((obj) => {
                return obj.hasOwnProperty('children')
            })
            return filteredData
        },
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.reportDriverScores.reportDriverScores.length
    },
    methods: {
        /**
         * Search the table data with search input
         */
        formatTotalHours(totalHours) {
            const days = Math.floor(totalHours / 24);
            const remainingHours = Math.floor(totalHours % 24);
            const remainingMinutes = Math.floor((totalHours * 60) % 60);
            const remainingSeconds = Math.floor((totalHours * 3600) % 60);

            return `${days} days ${String(remainingHours).padStart(2, '0')}:${String(
                remainingMinutes
            ).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
        },

        selectValues(data, key) {
            const result = []

            // Recursive helper function
            function selectHelper(obj) {
                const selectedValues = obj[key]
                if (selectedValues) {
                    result.push(selectedValues)
                }

                if (obj.children && Array.isArray(obj.children)) {
                    obj.children.forEach((child) => selectHelper(child))
                }
            }

            data.forEach((obj) => selectHelper(obj))
            return result
        },

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.filteredItems = filteredItems
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },

        changePerPage(perPage) {
            this.perPage = perPage
            this.refreshData(this.periode, this.filterDriver, this.filterGrade, this.fields)
        },

        changePage(page) {
            this.currentPage = page
            this.refreshData(this.periode, this.filterDriver, this.filterGrade, this.fields)
        },

        searchData: debounce(function () {
            this.refreshData(this.periode, this.filterDriver, this.filterGrade, this.fields)
        }, 500),

        refreshData(periode, filterDriver, filterGrade, fields) {
            this.reportDriverScores.reportDriverScores = []
            if (fields.length == 0) {
                this.reportDriverScores.reportDriverScores = []
                return
            }
            this.fields = fields
            this.isLoading = true
            this.periode = periode
            this.filterDriver = filterDriver
            this.filterGrade = filterGrade

            let filterDrivers = {}
            if (filterDriver !== undefined && filterDriver.length > 0) {
                filterDrivers = {
                    driverId: filterDriver,
                }
            }

            let filterGrades = {}
            if (filterGrade !== undefined && filterGrade.length > 0) {
                filterGrades = {
                    finalGrade: filterGrade,
                }
            }
            this.currentPage = this.perPage > 10 ? 1 : this.currentPage
            let filterVar = {
                month: this.momentM(periode[1]),
                year: this.momentY(periode[1]),
                pagination: {
                    page: this.currentPage,
                    show: this.perPage,
                },
                search: this.filter || undefined,
                orderBy: JSON.stringify({ createdOn: 'asc' }),
                ...filterDrivers,
                ...filterGrades,
            }

            this.selectedData = this.selectValues(fields, 'key')
            for (let i = 0; i < this.selectedData.length; i++) {
                if (
                    this.selectedData[i] === 'driverViolation' ||
                    this.selectedData[i] === 'deliveryViolation'
                ) {
                    this.selectedData.splice(i, 1)
                }
            }

            let self = this
            let getData = this.$apollo
                .query({
                    query: GET_REPORT_DRIVER_SCORES,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then((res) => {
                    let data = res.data
                    self.totalRows = data.reportDriverScores.reportDriverScores.pagination.total
                    if (self.totalRows === 0) {
                        self.reportDriverScores.reportDriverScores = []
                        self.isLoading = false
                        return []
                    }

                    self.reportDriverScores.reportDriverScores =
                        data.reportDriverScores.reportDriverScores.data
                    self.filteredItems = data.reportDriverScores.reportDriverScores.data

                    self.isLoading = false
                })

            return getData
        },

        openTable(periode, filterDriver, filterGrade, fields) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.refreshData(periode, filterDriver, filterGrade, fields)
                    this.openSection = false
                }, 500)
            })
        },

        downloadToExcel(periode, filterDriver, filterGrade, fields) {
            let filterDrivers = {}
            if (filterDriver !== undefined && filterDriver.length > 0) {
                filterDrivers = {
                    driverId: filterDriver,
                }
            }

            let filterGrades = {}
            if (filterGrade !== undefined && filterGrade.length > 0) {
                filterGrades = {
                    finalGrade: filterGrade,
                }
            }

            let filterVar = {
                month: this.momentM(periode[1]),
                year: this.momentY(periode[1]),
                column: this.selectValues(fields, 'header'),
                subtitle: `Periode : ${this.momentMMM(this.momentM(periode[1]))} ${this.momentY(
                    periode[1]
                )}`,
                ...filterDrivers,
                ...filterGrades,
            }

            let downloadProgress = {
                name: 'Penilaian Pengemudi ' + moment(periode[1]).format('MMM YYYY') + '.xlsx',
                periode: `${this.momentMMM(this.momentM(periode[1]))} ${this.momentY(periode[1])}`,
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'excel',
            }
            this.$store.commit('report/saveProgress', downloadProgress)

            let percentage = 0
            let intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25
                } else if (percentage == 75) {
                    percentage = 90
                } else if (percentage == 90) {
                    clearInterval(intervalDownload)
                }
                this.$store.commit('report/updateProgress', {
                    progress: downloadProgress,
                    percentage: percentage,
                })
            }, 500)

            let self = this
            this.$apollo
                .query({
                    query: EXPORT_EXCEL_REPORT_DRIVER_SCORES,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then((res) => {
                    let isSuccessful = res.data.excelReportDriverScores.isSuccessful
                    if (isSuccessful) {
                        clearInterval(intervalDownload)
                        self.$parent.$parent.$parent.refreshDownloadHistory()
                        setTimeout(() => {
                            self.$store.commit('report/updateProgress', {
                                progress: downloadProgress,
                                percentage: 100,
                            })
                            self.$store.commit('report/deleteProgress', downloadProgress)
                        }, 500)
                    } else {
                        clearInterval(intervalDownload)
                        self.$parent.$parent.$parent.refreshDownloadHistory()
                        setTimeout(() => {
                            self.$store.commit('report/updateProgress', {
                                progress: downloadProgress,
                                percentage: 90,
                            })
                            self.$store.commit('report/deleteProgress', downloadProgress)
                        }, 500)
                    }
                })
        },

        downloadToPdf(periode, filterDriver, filterGrade, fields) {
            let filterDrivers = {}
            if (filterDriver !== undefined && filterDriver.length > 0) {
                filterDrivers = {
                    driverId: filterDriver,
                }
            }
            let filterGrades = {}
            if (filterGrade !== undefined && filterGrade.length > 0) {
                filterGrades = {
                    alertCode: filterGrade,
                }
            }
            let filterVar = {
                month: this.momentM(periode[1]),
                year: this.momentY(periode[1]),
                column: this.selectValues(fields, 'header'),
                subtitle: `Periode : ${this.momentMMM(this.momentM(periode[1]))} ${this.momentY(
                    periode[1]
                )}`,
                ...filterDrivers,
                ...filterGrades,
            }

            let downloadProgress = {
                name: 'Penilaian Pengemudi ' + moment(periode[1]).format('MMM YYYY') + '.pdf',
                periode: moment(periode[1]).format('MMM YYYY'),
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'pdf',
            }
            this.$store.commit('report/saveProgress', downloadProgress)

            let percentage = 0
            let intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25
                } else if (percentage == 75) {
                    percentage = 90
                } else if (percentage == 90) {
                    clearInterval(intervalDownload)
                }
                this.$store.commit('report/updateProgress', {
                    progress: downloadProgress,
                    percentage: percentage,
                })
            }, 500)

            let self = this
            this.$apollo
                .query({
                    query: EXPORT_PDF_REPORT_DRIVER_SCORES,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache',
                })
                .then((res) => {
                    let isSuccessful = res.data.pdfReportDriverScores.isSuccessful
                    if (isSuccessful) {
                        clearInterval(intervalDownload)
                        self.$parent.$parent.$parent.refreshDownloadHistory()
                        setTimeout(() => {
                            self.$store.commit('report/updateProgress', {
                                progress: downloadProgress,
                                percentage: 100,
                            })
                            self.$store.commit('report/deleteProgress', downloadProgress)
                        }, 500)
                    } else {
                        clearInterval(intervalDownload)
                        self.$parent.$parent.$parent.refreshDownloadHistory()
                        setTimeout(() => {
                            self.$store.commit('report/updateProgress', {
                                progress: downloadProgress,
                                percentage: 90,
                            })
                            self.$store.commit('report/deleteProgress', downloadProgress)
                        }, 500)
                    }
                })
        },
    },
}
</script>